import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, SimpleChanges, ViewChild, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { default as GridColumnsJSON } from '../processed-transactions-columns.json';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { QuickSearchComponent } from 'app/Shared/Component/quick-search/quick-search.component';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { UserService } from 'app/Shared/Services/user.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { TabsModule } from 'primeng/tabs';
import { ProcessedTransactionsComponent } from '../processed-transactions.component';
import { OdrSummaryComponent } from '../odr-summary/odr-summary.component';
import { ActivatedRoute } from '@angular/router';
import { CATComparisonComponent } from '../cat-comparison/cat-comparison.component';

@Component({
  selector: 'app-odr-transaction',
  imports: [FilterPanelComponent, QuickSearchComponent,ProcessedTransactionsComponent,
    CommonModule, MatProgressSpinner, ToastModule,TabsModule,OdrSummaryComponent,
    TableModule, ButtonModule, DialogModule, FormsModule, MatTooltipModule,CATComparisonComponent
  ],
  templateUrl: './odr-transaction.component.html',
  styleUrl: './odr-transaction.component.scss',
})
export class OdrTransactionComponent implements OnInit, OnDestroy {
  @ViewChild(ProcessedTransactionsComponent)transactionDetailsComponent!:ProcessedTransactionsComponent
  @ViewChild(OdrSummaryComponent)trasactionSummaryComponent!:OdrSummaryComponent
  @ViewChild(CATComparisonComponent)trasactionComparisonComponent!:CATComparisonComponent
  quickFilterArray: any = GridColumnsJSON["Quick-Search-Fields"];
  GridColumns: any = GridColumnsJSON["Grid-Columns"];
  exportGridColumns: any = [];
    cols: any = [];
    isQuickViewOpenClose: boolean = false;
    Dataset: any[] = [];
    LastExecutionODRDate!: any[];
    DefaultFilterArray: any = [];
    isLoadingResults = false;
    Limit: any = { 'Start': '', 'End': '' };
    selectedRow: any = [];
    totalRecords: any;
    rowcount!: number;
    startLimit: any = 0;
    pageNumber: any = 1;
    priviousStartLimit: any;
    endLimit!: number;
    subscription!: Subscription;
    columnJson: any = [];
    filterCols: any = [];
    selectedTabIndex: any = 0;
    defaultTransactionType: any = [{label:'Orders',value:'Orders'},
          {label:'Routes',value:'Routes'},
          {label:'Executions',value:'Executions'}
        ];
    OrderConditionTypeDropdown:any =[{label:'Market Orders', value:'M'},
          {label:'Marketable Limit Orders', value:'ML'},
          {label:'Nonmarketable Limit Orders', value:'NL'},
          {label:'Other Orders', value:'O'}
        ]
    urlParamReportFromDate:any;
    urlParamReportToDate:any;
    urlParamFieldType: any = "";
    urlParamFieldTypeValue: any = "";
 
    constructor(
    private userService: UserService,
    private gridService: GridService,
    private emitterService: EmitterService,
    public constantService: ConstantService,
    private messageService: MessageService,
    private activatedRoute:ActivatedRoute) {
  }

  ngOnInit(): void {
    this.getActiveParameters();
    this.defaultFilter();
    this.loadInitialData();
    this.getColumns();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.defaultFilter();
    this.loadInitialData();
  }
  defaultFilter() {
    let date = this.userService.ODR_ProcessedTransactionReportDate;
    this.LastExecutionODRDate = [date, date];

    let instrumentTypeValue =  (this.urlParamFieldTypeValue == 'equitiesOrder' || this.urlParamFieldTypeValue == 'equitiesNonDirectedOrder' 
      || this.urlParamFieldTypeValue == 'equitiesRoutes' || this.urlParamFieldTypeValue == 'equitiesMarket' || this.urlParamFieldTypeValue == 'equitiesMarketableLimit' || this.urlParamFieldTypeValue == 'equitiesNonMarketableLimit' || this.urlParamFieldTypeValue == 'equitiesOther') ? 'E'
      :  (this.urlParamFieldTypeValue == 'OptionsOrder' || this.urlParamFieldTypeValue == 'optionsNonDirectedOrder'
      || this.urlParamFieldTypeValue == 'OptionsRoute' || this.urlParamFieldTypeValue == 'optionsMarket' || this.urlParamFieldTypeValue == 'optionsMarketableLimit' || this.urlParamFieldTypeValue == 'optionsNonMarketableLimit' || this.urlParamFieldTypeValue == 'optionsOther') ? 'O' : '';

    let venueNameFilter = (this.urlParamFieldType == 'Routes' && this.urlParamFieldTypeValue !== 'isReportableSymbol' && this.urlParamFieldTypeValue !== 'held' && this.urlParamFieldTypeValue !== 'nonDirected' 
      && this.urlParamFieldTypeValue !== 'equitiesRoutes' 
      && this.urlParamFieldTypeValue !== 'equitiesMarket' && this.urlParamFieldTypeValue !== 'equitiesMarketableLimit' && this.urlParamFieldTypeValue !== 'equitiesNonMarketableLimit' && this.urlParamFieldTypeValue !== 'equitiesOther'
      && this.urlParamFieldTypeValue !== 'snp500Routes' 
      && this.urlParamFieldTypeValue !== 'SNP500Market' && this.urlParamFieldTypeValue !== 'SNP500MarketableLimit' && this.urlParamFieldTypeValue !== 'SNP500NonMarketableLimit' && this.urlParamFieldTypeValue !== 'SNP500Other'
      && this.urlParamFieldTypeValue !== 'OptionsRoute' 
      && this.urlParamFieldTypeValue !== 'optionsMarket' && this.urlParamFieldTypeValue !== 'optionsMarketableLimit' && this.urlParamFieldTypeValue !== 'optionsNonMarketableLimit' && this.urlParamFieldTypeValue !== 'optionsOther'
      && this.urlParamFieldTypeValue) ? this.urlParamFieldTypeValue : "";


      let orderConditionValue = (this.urlParamFieldTypeValue == 'equitiesMarket' || this.urlParamFieldTypeValue == 'SNP500Market'|| this.urlParamFieldTypeValue == 'optionsMarket') ? 'M'
      : (this.urlParamFieldTypeValue == 'equitiesMarketableLimit' || this.urlParamFieldTypeValue == 'SNP500MarketableLimit'|| this.urlParamFieldTypeValue == 'optionsMarketableLimit') ? 'ML'
      : (this.urlParamFieldTypeValue == 'equitiesNonMarketableLimit' || this.urlParamFieldTypeValue == 'SNP500NonMarketableLimit'|| this.urlParamFieldTypeValue == 'optionsNonMarketableLimit') ? 'NL'
      : (this.urlParamFieldTypeValue == 'equitiesOther' || this.urlParamFieldTypeValue == 'SNP500Other'|| this.urlParamFieldTypeValue == 'optionsOther') ? 'O'
      :'';

    this.DefaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Date', 'columnname': 'reportDate', 'filterby': '', 
        'values': (this.urlParamReportFromDate && this.urlParamReportToDate) ? [this.urlParamReportFromDate, this.urlParamReportToDate] : this.LastExecutionODRDate, 
        'time': '', 'datatype': 'DateRange', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
      { "isdefault": "true", "label": "Directed", "columnname": "directed", "filterby": "=", "values": (this.urlParamFieldTypeValue == 'nonDirected' || this.urlParamFieldTypeValue == 'equitiesNonDirectedOrder' || this.urlParamFieldTypeValue == 'optionsNonDirectedOrder' ) ? 'false' : '', "time": "", "datatype": "boolean", "disabled": true, },
      { "isdefault": "true", "label": "InstrumentType", "columnname": "instrumentType", "filterby": "IS", "values": instrumentTypeValue, "time": "", "datatype": "String", "disabled": true, },
      { "isdefault": "true", "label": "NotHeld", "columnname": "notHeld", "filterby": "=", "values": this.urlParamFieldTypeValue == 'held' ? 'false' : '', "time": "", "datatype": "boolean", "disabled": true, },
      {
        isdefault: 'true',
        label: 'Order Condition',
        columnname: 'orderCondition',
        filterby: 'IS',
        values: orderConditionValue ? [orderConditionValue] : [],
        time: '',
        datatype: 'skip',
        disabled: 'true',
        dropdown: 'YES',
        dropdowntype: 'multiselect',
        dropdownvalue:this.OrderConditionTypeDropdown
      },
      { "isdefault": "true", "label": "Order ID", "columnname": "OrderID", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": true, },
      { "isdefault": "true", "label": "Symbol", "columnname": "Symbol", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": true, },
      {
        isdefault: 'true',
        label: 'Transactions',
        columnname: 'transaction',
        filterby: 'IS',
        values: this.urlParamFieldType ? [this.urlParamFieldType] : [],
        time: '',
        datatype: 'skip',
        disabled: 'true',
        dropdown: 'YES',
        dropdowntype: 'multiselect',
        dropdownvalue:this.defaultTransactionType
      },
      { "isdefault": "true", "label": "Venue Name", "columnname": "VenueName", "filterby": "IS", "values": venueNameFilter, "time": "", "datatype": "String", "disabled": true, },
    ];
    if (this.urlParamFieldType == 'Orders') {
      this.getActiveOrdersURLFilter();
    }
    else if (this.urlParamFieldType == 'Routes') {
      this.getActiveRoutesURLFilter();
    }
    else if (this.urlParamFieldType == 'Executions') { 
      this.getActiveExecutionsURLFilter();
    }
  }

getFilterArray(){
  if(this.selectedTabIndex === 2){
    return this.DefaultFilterArray.filter((filter:any)=>
    filter.columnname === 'reportDate');
  }
  return this.DefaultFilterArray;
}

 async loadInitialData() {
    if(!this.userService.ODR_ProcessedTransactionReportDate) {
      await this.userService.getODRLastReportedDate();
    }
    let date = this.userService.ODR_ProcessedTransactionReportDate ?? new Date();
    this.LastExecutionODRDate[0] = date;
    this.LastExecutionODRDate[1] = date;
    setTimeout(()=>{
    this.transactionDetailsComponent?.getData();
    this.trasactionSummaryComponent?.getData(); 
    this.trasactionComparisonComponent?.getComparisonData();
    })  
  }

  getColumns() {
    let column: any = this.GridColumns;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.columnJson = this.gridService.getGridColumns(column);
      this.cols = this.gridService.getGridColumns(column);
      this.filterCols = this.cols;
    }
  }

 updateDefaultArray($event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("All"); // Reset Quick Symbol Filter
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.transactionDetailsComponent?.getData();
    this.trasactionSummaryComponent?.getData(); 
    this.trasactionComparisonComponent?.getComparisonData();
 }

  clearQuickSearch($event: any) {
    this.emitterService.ResetQuickFilterPanelEvent.emit("All"); // Reset Quick Symbol Filter
    this.emitterService.isResetGridLimit.emit(true);
    this.DefaultFilterArray = $event;
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.transactionDetailsComponent?.getData();
    this.trasactionSummaryComponent?.getData(); 
    this.trasactionComparisonComponent?.getComparisonData();
  }


  FilterApplyFilterEvent(event: any) {
  this.emitterService.isResetGridLimit.emit(true);
  this.startLimit = 0;
  this.Limit.Start = 0;
  if (this.selectedTabIndex === 2) {
    this.transactionDetailsComponent?.getData(this.DefaultFilterArray);
    this.trasactionSummaryComponent?.getData(this.DefaultFilterArray);
    const comparisonFilter = this.DefaultFilterArray.filter(
      (filter: any) => filter.columnname === 'reportDate');
    this.trasactionComparisonComponent?.getComparisonData(comparisonFilter);
  } else {
     this.DefaultFilterArray = [];
     this.DefaultFilterArray = event;
     this.transactionDetailsComponent?.getData(this.DefaultFilterArray);   
     this.trasactionSummaryComponent?.getData(this.DefaultFilterArray);
     const comparisonFilter = this.DefaultFilterArray.filter(
     (filter: any) => filter.columnname === 'reportDate');
     this.trasactionComparisonComponent?.getComparisonData(comparisonFilter);
  }
}

  getActiveParameters(){
   this.urlParamReportFromDate = this.activatedRoute.snapshot.queryParamMap.get('fromDate');
   this.urlParamReportToDate = this.activatedRoute.snapshot.queryParamMap.get('toDate');
   this.urlParamFieldType = this.activatedRoute.snapshot.queryParamMap.get('transactionType');
   this.urlParamFieldTypeValue = this.activatedRoute.snapshot.queryParamMap.get('value');
   if(this.urlParamReportFromDate && this.urlParamReportToDate && this.urlParamFieldType){
   this.selectedTabIndex = 1;
   }
  }
  getActiveOrdersURLFilter() {
    if (this.urlParamFieldType == 'Orders' && (this.urlParamFieldTypeValue == 'isReportableSymbol' || this.urlParamFieldTypeValue == 'held' || this.urlParamFieldTypeValue == 'OptionsOrder' || this.urlParamFieldTypeValue == 'nonDirected'
      || this.urlParamFieldTypeValue == 'equitiesNonDirectedOrder' || this.urlParamFieldTypeValue == 'optionsNonDirectedOrder' || this.urlParamFieldTypeValue == 'equitiesOrder')) {
      this.DefaultFilterArray.push({
        "isdefault": "true", "label": "IsReportableSymbol", "columnname": "isReportableSymbol", "filterby": "IS", "values": "true", "time": "", "datatype": "boolean", "disabled": true,
      })
    }
    if (this.urlParamFieldType == 'Orders' && this.urlParamFieldTypeValue == 'SNP500') {
      this.DefaultFilterArray.push(
        { "isdefault": "true", "label": "SNP500", "columnname": "SNP500", "filterby": "=", "values": "true", "time": "", "datatype": "boolean", "disabled": true, },
        { "isdefault": "true", "label": "IsReportableSymbol", "columnname": "isReportableSymbol", "filterby": "=", "values": "true", "time": "", "datatype": "boolean", "disabled": true, })
    }
    if (this.urlParamFieldType == 'Orders' && this.urlParamFieldTypeValue && this.urlParamFieldTypeValue != 'isReportableSymbol' && this.urlParamFieldTypeValue != 'equitiesOrder' && this.urlParamFieldTypeValue != 'SNP500' && this.urlParamFieldTypeValue != 'held'
      && this.urlParamFieldTypeValue != 'OptionsOrder' && this.urlParamFieldTypeValue != 'nonDirected' && this.urlParamFieldTypeValue != 'equitiesNonDirectedOrder'
      && this.urlParamFieldTypeValue != 'optionsNonDirectedOrder') {
      this.DefaultFilterArray.push({
        "isdefault": "true", "label": "Customer", "columnname": "customer", "filterby": "IS", "values": (this.urlParamFieldType == 'Orders' && this.urlParamFieldTypeValue) ? this.urlParamFieldTypeValue : "", "time": "", "datatype": "String", "disabled": true,
      })
    }
  }
  getActiveRoutesURLFilter(){
     if (this.urlParamFieldType == 'Routes' && (this.urlParamFieldTypeValue == 'isReportableSymbol' || this.urlParamFieldTypeValue == 'held')){
      this.DefaultFilterArray.push({
        "isdefault": "true", "label": "IsReportableSymbol", "columnname": "isReportableSymbol", "filterby": "IS", "values": "true", "time": "", "datatype": "boolean", "disabled": true,
      })
    }
     if (this.urlParamFieldType == 'Routes' && (this.urlParamFieldTypeValue == 'equitiesRoutes' || this.urlParamFieldTypeValue == 'equitiesMarket' || this.urlParamFieldTypeValue == 'equitiesMarketableLimit' || this.urlParamFieldTypeValue == 'equitiesNonMarketableLimit' || this.urlParamFieldTypeValue == 'equitiesOther')){
      this.DefaultFilterArray.push(
        { "isdefault": "true", "label": "SNP500", "columnname": "SNP500", "filterby": "=", "values": "false", "time": "", "datatype": "boolean", "disabled": true, },
        { "isdefault": "true", "label": "Directed", "columnname": "directed", "filterby": "=", "values": 'false', "time": "", "datatype": "boolean", "disabled": true, })
    }
    if (this.urlParamFieldType == 'Routes' && (this.urlParamFieldTypeValue == 'snp500Routes' 
      || this.urlParamFieldTypeValue == 'SNP500Market' || this.urlParamFieldTypeValue == 'SNP500MarketableLimit' || this.urlParamFieldTypeValue == 'SNP500NonMarketableLimit' || this.urlParamFieldTypeValue == 'SNP500Other' 
    )) {
      this.DefaultFilterArray.push(
        { "isdefault": "true", "label": "SNP500", "columnname": "SNP500", "filterby": "=", "values": "true", "time": "", "datatype": "boolean", "disabled": true, },
        { "isdefault": "true", "label": "Directed", "columnname": "directed", "filterby": "=", "values": 'false', "time": "", "datatype": "boolean", "disabled": true, })
      }
      if (this.urlParamFieldType == 'Routes' && this.urlParamFieldTypeValue == 'OptionsRoute' || this.urlParamFieldTypeValue == 'optionsMarket' || this.urlParamFieldTypeValue == 'optionsMarketableLimit' || this.urlParamFieldTypeValue == 'optionsNonMarketableLimit' || this.urlParamFieldTypeValue == 'optionsOther')
       {
      this.DefaultFilterArray.push(
        { "isdefault": "true", "label": "Directed", "columnname": "directed", "filterby": "=", "values": 'false', "time": "", "datatype": "boolean", "disabled": true, })
      }
  }
  getActiveExecutionsURLFilter(){
      if (this.urlParamFieldType == 'Executions' && this.urlParamFieldTypeValue) {
      this.DefaultFilterArray.push({
        "isdefault": "true", "label": "ExecBroker", "columnname": "execBroker", "filterby": "IS", "values": (this.urlParamFieldType == 'Executions' && this.urlParamFieldTypeValue) ? this.urlParamFieldTypeValue : "", "time": "", "datatype": "String", "disabled": true,
      })
    } 
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
}
